import { OnboardingData, UserState } from './types'
import { Status } from '../../types'

export const updateStatus = (state: any, value: Status | null) => {
	state.status = value
}

export const saveOnboardingData = (state: UserState, action: { payload: Partial<OnboardingData> }) => {
	state.onboardingData = { ...state.onboardingData, ...action.payload } as OnboardingData
}

export const saveUserData = (state: UserState, action: any) => {
	state.userData = { status: Status.IDLE, data: action.payload }
}

export const saveMetrics = (state: UserState, action: any) => {
	state.metrics = { status: Status.IDLE, data: action.payload }
}

export const saveStripeCustomerData = (state: UserState, action: any) => {
	state.stripeCustomerData = { status: Status.IDLE, data: { ...state.stripeCustomerData.data, ...action.payload } }
}

export const resetStripeCustomerData = (state: UserState) => {
	saveStripeCustomerData(state, { payload: { client_secret: null, setup_intent_id: null, contact_id: null } })
	sessionStorage.removeItem('stripe_customer_id')
	sessionStorage.removeItem('stripe_setup_intent_id')
}
